import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import { siteSettings } from "@/content/site";
import { Ear, MagnifyingGlass, Compass, FileText, Hammer, HandHeart, ArrowRight } from "@phosphor-icons/react";

const STEPS = [
  { icon: Ear, t: "Ascolto", d: "Prima di parlare di soluzioni, capiamo come vivi il bagno e cosa vuoi migliorare." },
  { icon: MagnifyingGlass, t: "Sopralluogo gratuito", d: "Verifichiamo misure, spazi, impianti e condizioni reali del bagno." },
  { icon: Compass, t: "Scelte guidate", d: "Ti aiutiamo a orientarti tra materiali, finiture e soluzioni senza lasciarti davanti a troppe opzioni confuse." },
  { icon: FileText, t: "Proposta chiara", d: "Costruiamo una proposta ordinata, comprensibile e coerente con le tue esigenze." },
  { icon: Hammer, t: "Lavori coordinati", d: "Organizziamo le fasi operative per ridurre stress, ritardi e imprevisti." },
  { icon: HandHeart, t: "Consegna e assistenza", d: "Controlliamo il risultato e restiamo il tuo riferimento anche dopo la consegna." },
];

export default function MetodoOasi() {
  return (
    <div className="bg-warm-white min-h-screen">
      <Navbar />
      <section className="section-pad">
        <div className="max-w-5xl mx-auto px-5 md:px-10">
          <div className="overline mb-4">Il metodo</div>
          <h1 className="font-display text-4xl md:text-6xl leading-tight mb-5">Il Metodo Oasi: meno confusione, più controllo.</h1>
          <p className="text-[#5C5C59] text-base md:text-lg max-w-2xl">Un percorso pensato per rendere la ristrutturazione del bagno più chiara, ordinata e serena.</p>

          <div className="mt-14 space-y-5">
            {STEPS.map((st, i) => {
              const Icon = st.icon;
              return (
                <div key={i} className="card-soft p-6 md:p-8 flex gap-5 items-start">
                  <div className="w-12 h-12 rounded-full bg-sand-soft flex items-center justify-center flex-shrink-0">
                    <Icon size={22} weight="light" className="text-oasi-green" />
                  </div>
                  <div>
                    <div className="overline mb-1">Step {i + 1}</div>
                    <h3 className="font-display text-2xl mb-2">{st.t}</h3>
                    <p className="text-[#5C5C59] leading-relaxed">{st.d}</p>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="mt-14 text-center">
            <Link to="/prenota-sopralluogo" className="btn-primary inline-flex items-center gap-2 px-7 py-4 rounded-full text-sm">
              Richiedi sopralluogo gratuito <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </section>
      <Footer settings={siteSettings} />
      <WhatsAppFloat number={siteSettings.whatsapp_number} />
    </div>
  );
}
